const colors = {
    primary: '#F36E21',
    info: "#111111",
    success: '#3FB436',
    warning: '#EE9600',
    danger: '#E30404',
};

export default colors;